@include media-breakpoint-up(xl) {
    .app-nav {
        display: flex;
        max-height: none !important; //override JS style from mobile
        align-items: center;

        .contact-us {
            min-width: 128px;
            height: 48px;
            @include margin-direction(top, -24);

            &.mobile {
                display: none;
            }
        }

        .node {
            @include padding-direction(bottom, 30);
            @include margin-direction(right, 24);

            &.last {
                @include margin-direction(right, 33);
            }

            .parent {
                padding: 0;

                a {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    color: #fff;
                    @include text-size(16);
                    @include line-height(24);
                    font-family: $font-family-primary-bold;
                    text-decoration: none;

                    svg {
                        @include svg-format(16px, 16px, $primary);
                        @include margin-direction(left, 8);
                        transition: all 500ms;
                        margin-top: 6px;
                    }
                }

                .parent-toggle {
                    display: none;
                }
            }

            .sub {
                display: none;
                position: absolute;
                background: #fff;
                z-index: 15;

                &.mega-children {
                    left: 0;
                    width: 100%;
                    min-height: 280px;
                    top: 100%;

                    .nav-wrapper {
                        display: flex;
                        padding-left: 0;

                        .children {
                            flex-grow: 1;
                            padding-bottom: 0;

                            .row {
                                align-items: flex-start;
                            }
                        }
                    }
                }

                &.simple-children {
                    display: none;
                    min-width: 250px;
                    width: 100%;
                    right: 0;
                    min-height: 280px;
                    top: 100%;

                    .simple-children-cta__wrapper {

                        display: flex;
                        justify-content: space-between;

                        .simple-children__links {
                            @include padding-direction(top, 45);
                            @include padding-direction(bottom, 25);

                            a {
                                display: flex;
                                align-items: center;
                                @include margin-direction(bottom, 40);
                                text-decoration: none;
                                color: $gray-dark;
                                max-width: 388px;
                                height: 69px;

                                .icon-wrapper {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    max-width: 69px;
                                    min-width: 69px;
                                    max-height: 69px;
                                    min-height: 69px;
                                    border-radius: 100%;
                                    border: $secondary solid 2px;
                                    @include margin-direction(right, 16);

                                    &::before {
                                        background: transparent linear-gradient(135deg, $tertiary 0%, $quarternary 100%) 0% 0% no-repeat padding-box;
                                        content: '';
                                        display: block;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        width: 0;
                                        height: 0;
                                        z-index: -1;
                                        transform: translate(-50%, -50%);
                                        border-radius: 100%;
                                        transition: all 0.3s ease-in-out;
                                    }


                                    svg {
                                        max-width: 27px;
                                        min-width: 27px;
                                        max-height: 32px;
                                        min-height: 32px;
                                        color: $tertiary;
                                    }

                                }

                                .text-wrapper {

                                    .title {
                                        font-family: $font-family-primary-bold;
                                        @include text-size(16);
                                        @include line-height(24);

                                        svg {
                                            @include svg-format(14px, 16px, $primary);
                                            transition: all 300ms;
                                        }
                                    }

                                    .description {
                                        font-family: $font-family-primary;
                                        @include text-size(14);
                                        @include line-height(22);
                                    }
                                }

                                &:hover,
                                &:focus {

                                    .icon-wrapper {

                                        &::before {
                                            width: 69px;
                                            height: 69px;
                                        }

                                        svg {
                                            color: #FFF;

                                        }
                                    }

                                    .text-wrapper {

                                        .title {
                                            text-decoration: underline;

                                            svg {
                                                transform: translateX(4px);
                                            }
                                        }
                                    }


                                }
                            }
                        }
                    }
                }

                .children {
                    @include padding-direction(top, 24);
                    display: flex;
                    // flex-wrap: wrap;
                    flex-direction: column;
                    flex-grow: 1;
                }

                .children-mobile {
                    display: none;
                }

                .children-wrapper {

                    .child {
                        @include margin-direction(bottom, 32);

                        &:nth-child(2n) {
                            margin-bottom: 0;
                        }

                        a {
                            color: $gray-dark;
                            font-family: $font-family-primary-bold;
                            display: flex;
                            align-items: center;
                            @include text-size(16);
                            @include line-height(24);
                            text-decoration: none;

                            svg {
                                @include svg-format(14px, 16px, $primary);
                                @include margin-direction(left, 6);
                                transition: all 300ms;
                            }

                            &:hover,
                            &:focus {

                                svg {
                                    transform: translateX(4px);
                                }
                            }
                        }

                        .third-level {

                            a {
                                color: $gray-dark;
                                display: inline-block;
                                @include margin-direction(bottom, 8);
                                text-decoration: underline;
                                @include text-size(14);
                                @include line-height(22);
                                font-family: $font-family-primary;

                                &:hover,
                                &:focus {
                                    text-decoration: none;
                                }
                            }
                        }
                    }
                }

                .cta {
                    width: 287px;
                    height: 100%;
                    min-height: 391px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: center;
                    background-size: cover;
                    background-position: center;
                    background: $secondary;

                    .cta-content {
                        @include paddings(32,24,32,24);
                        color: #fff;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        background: transparent linear-gradient(180deg, #122E5200 0%, #122E52E6 56%, #122E52 100%) 0% 0% no-repeat padding-box;

                        .cta-title {
                            font-family: $font-family-primary-bold;
                            @include text-size(16);
                            @include line-height(24);
                            @include margin-direction(bottom, 24);
                            text-align: center;
                        }

                        .cta-description,
                        .cta-label {
                            font-family: $font-family-primary;
                            @include text-size(14);
                            @include line-height(22);
                            @include margin-direction(bottom, 25);
                            text-align: center;
                        }

                        .cta-label {
                            @include margin-direction(bottom, 16);
                        }
                    }
                }

            }

            &:hover,
            &:focus-within {
                .parent {
                    a {
                        text-decoration: underline;

                        svg {
                            transform: rotate(180deg);
                        }
                    }
                }

                .sub {
                    display: block;
                    animation: subNavIn 0.2s ease-in-out forwards;

                    .banner-text {
                        background: transparent linear-gradient(135deg, $tertiary 0%, $quarternary 100%) 0% 0% no-repeat padding-box;
                        @include padding-direction(top, 19);
                        @include padding-direction(bottom, 19);
                        color: white;

                    }

                    &.simple-children {
                        display: block;
                    }
                }
            }
        }
    }
}

@include media-breakpoint-down(xl) {
    .app-nav {
        background: $gray-dark;
        position: absolute;
        left: 0;
        top: 97px;
        width: calc(100%);
        overflow-y: auto;
        @include padding-direction(bottom, 26);
        transition: opacity 300ms;

        .contact-us {
            display: none;

            &.mobile {
                display: block;
                @include margin-direction(top, 32);
                @include margin-direction(bottom, 32);
            }

            a {

                &:hover,
                &:focus {
                    transform: translateY(0);
                    background: $primary;
                    color: $gray-dark;
                }
            }
        }

        .node {
            @include margin-direction(bottom, 32);

            &.last {
                margin-bottom: 0;
            }


            .parent {
                display: flex;

                a {
                    color: #FFF;
                    text-decoration: none;
                    display: block;
                    flex-grow: 1;
                    user-select: none;
                    font-family: $font-family-primary-bold;

                    svg {
                        display: none;
                    }
                }

                .parent-toggle {
                    border: 2px solid $primary;
                    display: flex;
                    border-radius: 50%;
                    justify-content: center;
                    align-items: center;
                    width: 30px;
                    height: 30px;

                    span {
                        display: block;
                    }

                    span+span {
                        display: none;
                    }

                    svg {
                        @include svg-format(14px, 16px, #FFF);
                        transition: all 350ms;
                    }
                }
            }

            .sub {
                display: none;
                background: #FFF;

                .banner-text {
                    background: transparent linear-gradient(135deg, $tertiary 0%, $quarternary 100%) 0% 0% no-repeat padding-box;
                    @include padding-direction(top, 16);
                    @include padding-direction(bottom, 16);
                    color: white;
                    text-align: center;
                    @include text-size(14);
                    @include line-height(22);
                }

                &.simple-children {
                    display: none;
                    min-width: 250px;
                    width: 100%;
                    right: 0;
                    min-height: 280px;
                    top: 100%;
                    overflow-x: hidden;

                    .simple-children-cta__wrapper {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        @include padding-direction(bottom, 30);

                        .simple-children__links {
                            @include padding-direction(top, 40);

                            a {
                                display: flex;
                                align-items: center;
                                @include margin-direction(bottom, 40);
                                text-decoration: none;
                                color: $gray-dark;

                                .icon-wrapper {
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    max-width: 69px;
                                    min-width: 69px;
                                    max-height: 69px;
                                    min-height: 69px;
                                    border-radius: 100%;
                                    border: $secondary solid 2px;
                                    @include margin-direction(right, 16);

                                    &::before {
                                        background: transparent linear-gradient(135deg, $tertiary 0%, $quarternary 100%) 0% 0% no-repeat padding-box;
                                        content: '';
                                        display: block;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        width: 0;
                                        height: 0;
                                        z-index: -1;
                                        transform: translate(-50%, -50%);
                                        border-radius: 100%;
                                        transition: all 0.3s ease-in-out;
                                    }


                                    svg {
                                        max-width: 27px;
                                        min-width: 27px;
                                        max-height: 32px;
                                        min-height: 32px;
                                        color: $tertiary;
                                    }

                                }

                                .text-wrapper {

                                    .title {
                                        font-family: $font-family-primary-bold;
                                        @include text-size(16);
                                        @include line-height(24);

                                        svg {
                                            @include svg-format(14px, 16px, $primary);
                                            transition: all 300ms;
                                        }
                                    }

                                    .description {
                                        font-family: $font-family-primary;
                                        @include text-size(14);
                                        @include line-height(22);
                                    }
                                }
                            }
                        }
                    }
                }

                .nav-wrapper {
                    @include padding-direction(bottom, 30);
                }

                .children {
                    display: none;
                }

                .children-mobile {
                    display: block;
                    @include padding-direction(top, 39);

                    .child {
                        @include margin-direction(bottom, 32);

                        .child-link {
                            display: flex;
                            @include margin-direction(bottom, 20);

                            a {
                                color: $gray-dark;
                                display: block;
                                flex-grow: 1;
                                user-select: none;
                                text-decoration: none;
                                font-family: $font-family-primary-bold;

                                svg {
                                    display: none;
                                }
                            }

                            .parent-toggle {
                                border: 2px solid $primary;
                                display: flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                width: 30px;
                                height: 30px;

                                span {
                                    display: block;
                                }

                                span+span {
                                    display: none;
                                }

                                svg {
                                    @include svg-format(14px, 16px, $gray-dark);
                                    transition: all 350ms;
                                }
                            }
                        }

                        .third-level {
                            display: none;

                            a {
                                @include padding-direction(bottom, 20);
                                display: block;
                                color: $gray-dark;
                                @include text-size(14);
                                @include line-height(22);
                                font-family: $font-family-primary;

                                &:last-of-type {
                                    padding-bottom: 0;
                                }
                            }
                        }

                        &.open {

                            .child-link {

                                .parent-toggle {
                                    span {
                                        display: none;
                                    }

                                    span+span {
                                        display: block;
                                    }
                                }
                            }

                            .third-level {
                                display: block;
                            }
                        }
                    }
                }

                .cta {
                    width: 100%;
                    height: 275px;
                    background-size: cover;
                    background-position: center;


                    .cta-content {
                        height: 100%;
                        @include paddings(32,24,32,24);
                        color: #fff;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: flex-end;
                        background: transparent linear-gradient(180deg, #122E5200 0%, #122E52E6 56%, #122E52 100%) 0% 0% no-repeat padding-box;

                        .cta-title {
                            font-family: $font-family-primary-bold;
                            @include text-size(16);
                            @include line-height(24);
                            @include margin-direction(bottom, 24);
                            text-align: center;
                        }

                        .cta-description,
                        .cta-label {
                            font-family: $font-family-primary;
                            @include text-size(14);
                            @include line-height(22);
                            @include margin-direction(bottom, 25);
                            text-align: center;
                        }

                        .cta-label {
                            @include margin-direction(bottom, 16);
                        }
                    }
                }
            }

            &.open {
                .parent {

                    .parent-toggle {
                        span {
                            display: none;
                        }

                        span+span {
                            display: block;
                        }
                    }
                }

                .sub {
                    display: block;
                    background: white;
                    @include margin-direction(top, 32);
                }
            }

        }

    }
}

@keyframes subNavIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}